<template>
  <div
    :key="themeKey"
    :style="[shineStyle, { fontSize: 'clamp(30px, 5vw, 44px)' }]"
    class="shine-text leading-[1.2] font-semibold font-avant-demi"
    :class="appendClass"
  >
    {{ text }}
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const colorMode = useColorMode();

type Props = {
  text?: string;
  appendClass?: string;
};

withDefaults(defineProps<Props>(), {
  text: "",
  appendClass: "",
});

const themeKey = computed(() => colorMode.preference);

const shineStyle = computed(() => {
  const isDark = colorMode.preference === "dark";
  const base = isDark ? "#FFFFFF" : "#000000";
  const shine = "#CDA0FE";
  return {
    color: base,
    backgroundImage: `linear-gradient(90deg, ${base} 0%, ${base} 35%, ${shine} 42%, ${shine} 48%, ${base} 55%, ${base} 100%)`,
  };
});
</script>

<style scoped>
@keyframes shineSwipe {
  0% {
    background-position: 200% center;
  }
  100% {
    background-position: -200% center;
  }
}

.shine-text {
  background-size: 200% 100%;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  animation: shineSwipe 6s ease-in-out infinite;
}
</style>
